import { ReactNode, JSX } from 'react';
import { ServerConfigContext } from '@src/contexts/server-config-context';

export interface ServerConfigProps {
  headerEnv: string | null;
  awsRegionShort: string | null;
  appVersion: string | null;
  lemonadeStates: string[];
  akamaiBotHeader: string;
  proxyBasePath: string;
  abTestingEnabled?: boolean;
  smsConsentEnabled?: boolean;
  addressCheckEnabled?: boolean;
  trupanionPreferredRetailerEnabled?: boolean;
  guestQuoteEnabled?: boolean;
  preGuestQuoteEmailCaptureEnabled?: boolean;
  isCSR?: boolean;
  quoteSimplificationEnabled?: boolean;
  breedEducationModuleEnabled?: boolean;
  chewyAnalyticsAleEnabled?: boolean;
  visionM2Enabled?: boolean;
  lemonadeEnhancedPreventativeBenefitsStates?: string[];
  children: ReactNode;
}

export const ServerConfigProvider = ({
  headerEnv,
  awsRegionShort,
  appVersion,
  lemonadeStates,
  akamaiBotHeader,
  proxyBasePath,
  abTestingEnabled = true,
  smsConsentEnabled = true,
  addressCheckEnabled = true,
  trupanionPreferredRetailerEnabled = false,
  guestQuoteEnabled = false,
  preGuestQuoteEmailCaptureEnabled = false,
  isCSR = false,
  quoteSimplificationEnabled = false,
  breedEducationModuleEnabled = false,
  chewyAnalyticsAleEnabled = false,
  visionM2Enabled = false,
  lemonadeEnhancedPreventativeBenefitsStates,
  children,
}: ServerConfigProps): JSX.Element => {
  return (
    <ServerConfigContext.Provider
      value={{
        headerEnv,
        awsRegionShort,
        appVersion,
        lemonadeStates,
        akamaiBotHeader,
        proxyBasePath,
        abTestingEnabled,
        smsConsentEnabled,
        addressCheckEnabled,
        trupanionPreferredRetailerEnabled,
        guestQuoteEnabled,
        preGuestQuoteEmailCaptureEnabled,
        isCSR,
        quoteSimplificationEnabled,
        breedEducationModuleEnabled,
        chewyAnalyticsAleEnabled,
        visionM2Enabled,
        lemonadeEnhancedPreventativeBenefitsStates,
      }}
    >
      {children}
    </ServerConfigContext.Provider>
  );
};
